import { render, staticRenderFns } from "./NotificacionesNewOrEditDemo.vue?vue&type=template&id=fc38f85e"
import script from "./NotificacionesNewOrEditDemo.vue?vue&type=script&lang=js"
export * from "./NotificacionesNewOrEditDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports